import React, { useState, useEffect } from 'react';
import { Row, Col, Spinner, Button, Container, Carousel } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import request from '../../../../../request';
import Notify from '../../../../compartidos/Notify';
import DeviceActivator from './DeviceActivator';
import '../Turnero.css';
import { motion, AnimatePresence } from 'framer-motion';

// Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCheckCircle, faMapMarkerAlt, faIdCard, faPrint, faChevronRight, faInfoCircle } from '@fortawesome/free-solid-svg-icons';

/**
 * TurnTotem - Kiosk/Totem View for turn registration
 */
const TurnTotem = ({ ipserv }) => {
    const [step, setStep] = useState('selecting_type'); // selecting_type, entering_dni, success, error
    const [loading, setLoading] = useState(false);
    const [types, settypes] = useState([]);
    const [selectedType, setSelectedType] = useState(null);
    const [dni, setDni] = useState('');
    const [resultTurn, setResultTurn] = useState(null);
    const [sucursalInfo, setSucursalInfo] = useState(null);
    const [isActivated, setIsActivated] = useState(!!localStorage.getItem('dm_installation_token'));
    const [multimedia, setMultimedia] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);

    const location = useLocation();

    // Identify Branch (URL > Storage)
    const getSucursalId = () => {
        const params = new URLSearchParams(location.search);
        const urlId = params.get('sucursalId');
        if (urlId) {
            localStorage.setItem('dm_totem_sucursal', urlId);
            return urlId;
        }
        return localStorage.getItem('dm_totem_sucursal');
    };

    const branchId = getSucursalId();

    const loadBranchInfo = () => {
        if (!branchId || !isActivated) {
            if (!branchId) setStep('error');
            return;
        }

        // Fetch all branches to find ours
        request.Get(ipserv + 'databranchestotvis', { sucursalId: branchId }, r => {
            if (r.success) {
                setSucursalInfo(r.rows);
            } else {
                setStep('error');
            }
        });
    };

    const loadTypes = () => {
        if (!branchId || !isActivated) return;
        setLoading(true);
        request.Get(ipserv + 'getTurneroTipostotvis', { sucursalId: branchId }, r => {
            if (r.success) {
                settypes(r.rows || []);
            }
            setLoading(false);
        });
    };

    const handleSelectType = (type) => {
        setSelectedType(type);
        setStep('entering_dni');
    };

    const handleKeypadPress = (val) => {
        if (dni.length < 10) setDni(dni + val);
    };

    const handleKeypadDelete = () => {
        setDni(dni.slice(0, -1));
    };

    const handleConfirmTurn = () => {
        if (dni.length < 7) {
            Notify({ type: 'info', text: 'Por favor ingrese un DNI válido' });
            return;
        }
        setLoading(true);
        request.Post(ipserv + 'registerNewTurn', {
            typeId: selectedType.TipoId,
            dni,
            sucursalId: branchId
        }, r => {
            if (r.success) {
                setResultTurn(r.data.turnNumber); // e.g. "CAJ-042"
                setStep('success');
                // Disparar Impresion
                setTimeout(() => window.print(), 300);
                // Auto reset after 10 seconds
                setTimeout(() => resetFlow(), 10000);
            } else {
                Notify({ type: 'fail', text: r.message || 'Error al registrar turno' });
            }
            setLoading(false);
        });
    };

    const resetFlow = () => {
        setStep('selecting_type');
        setDni('');
        setSelectedType(null);
        setResultTurn(null);
    };

    useEffect(() => {
        console.log(types)
    }, [types]);

    useEffect(() => {
        console.log(selectedType)
    }, [selectedType]);



    const fetchMultimedia = () => {
        if (!branchId || !isActivated || types.length === 0) return;

        const promises = types.map(t =>
            new Promise((resolve) => {
                request.Get(ipserv + 'getTurneroParamstotvis', {
                    typeAcronym: t.TipoId,
                    sucursalId: branchId
                }, r => {
                    resolve(r.success ? (r.data || []) : []);
                });
            })
        );

        Promise.all(promises).then(results => {
            const combined = results.flat();
            // Deduplicate by media URL
            const unique = combined.filter((v, i, a) => a.findIndex(t => t.ParamValor === v.ParamValor) === i);
            setMultimedia(unique);
        });
    };

    useEffect(() => {
        loadBranchInfo();
        loadTypes();
    }, [branchId, isActivated]);

    useEffect(() => {
        if (types.length > 0) fetchMultimedia();
    }, [types]);

    return (
        <div className="turnero-container p-0 overflow-hidden">
            {!isActivated && branchId && (
                <DeviceActivator
                    sucursalId={branchId}
                    onActivated={() => setIsActivated(true)}
                />
            )}

            <div className="totem-split-container">
                {/* LEFT SIDE: MULTIMEDIA PANEL */}
                <div className="totem-media-panel">
                    {multimedia.length > 0 ? (
                        <Carousel
                            fade
                            controls={false}
                            indicators={false}
                            interval={8000}
                            className="h-100"
                        >
                            {multimedia.map((m, idx) => (
                                <Carousel.Item key={idx} className="h-100">
                                    <div className="media-wrapper h-100">
                                        {m.MultimediaTipo.toLowerCase().includes('video') ? (
                                            <video
                                                src={m.UrlMultimedia}
                                                autoPlay
                                                loop
                                                muted
                                                className="w-100 h-100 object-fit-cover"
                                            />
                                        ) : (
                                            <img
                                                src={m.UrlMultimedia}
                                                alt="Ads"
                                                className="w-100 h-100 object-fit-cover"
                                            />
                                        )}
                                        <div className="media-overlay"></div>
                                    </div>
                                </Carousel.Item>
                            ))}
                        </Carousel>
                    ) : (
                        <div className="media-placeholder h-100 d-flex align-items-center justify-content-center">
                            <div className="text-center opacity-30">
                                <FontAwesomeIcon icon={faInfoCircle} size="4x" className="mb-3" />
                                <h3>TU FILA</h3>
                                <p>SISTEMA DE TURNOS</p>
                            </div>
                        </div>
                    )}

                    <div className="brand-floating-logo">
                        <h2 className="m-0">Tu<b>Fila</b></h2>
                    </div>
                </div>

                {/* RIGHT SIDE: INTERACTIVE WORKFLOW */}
                <div className="totem-workflow-panel">
                    <AnimatePresence mode="wait">
                        {step === 'selecting_type' && (
                            <motion.div
                                key="step1"
                                initial={{ opacity: 0, x: 50 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: -50 }}
                                className="workflow-content animate-in"
                            >
                                <div className="workflow-header mb-5 text-center">
                                    <div className="branch-badge mb-3">
                                        <FontAwesomeIcon icon={faMapMarkerAlt} className="mr-2" />
                                        {sucursalInfo || 'Sucursal Principal'}
                                    </div>
                                    <h1 className="display-4 font-weight-bold mb-2">BIENVENIDO</h1>
                                    <p className="text-muted h4">¿Qué trámite desea realizar?</p>
                                </div>

                                <div className="sector-grid-totem mt-5">
                                    {loading ? (
                                        <div className="text-center py-5">
                                            <Spinner animation="border" variant="primary" />
                                        </div>
                                    ) : (
                                        types.map((t, idx) => (
                                            <motion.button
                                                key={t.TipoId}
                                                whileHover={{ scale: 1.02 }}
                                                whileTap={{ scale: 0.98 }}
                                                className="totem-sector-btn shadow-lg"
                                                onClick={() => handleSelectType(t)}
                                            >
                                                <div className="btn-inner">
                                                    <div className="type-acronym">{t.TipoAcronimo}</div>
                                                    <div className="type-name">{t.TipoNombre}</div>
                                                    <FontAwesomeIcon icon={faChevronRight} className="arrow-icon" />
                                                </div>
                                            </motion.button>
                                        ))
                                    )}
                                </div>
                            </motion.div>
                        )}

                        {step === 'entering_dni' && (
                            <motion.div
                                key="step2"
                                initial={{ opacity: 0, x: 50 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: -50 }}
                                className="workflow-content"
                            >
                                <div className="text-left mb-5">
                                    <button className="back-btn-premium" onClick={() => setStep('selecting_type')}>
                                        <FontAwesomeIcon icon={faArrowLeft} />
                                    </button>
                                </div>

                                <div className="workflow-header mb-4">
                                    <h2 className="display-4 font-weight-bold">SU DNI</h2>
                                    <p className="text-muted h5">Trámite: <span className="text-primary font-weight-bold">{selectedType.TipoNombre}</span></p>
                                </div>

                                <div className="dni-input-display shadow-lg mb-4">
                                    <FontAwesomeIcon icon={faIdCard} className="dni-icon" />
                                    <div className="dni-numbers">
                                        {dni || <span className="placeholder">00000000</span>}
                                    </div>
                                    {dni.length > 0 && <button className="clear-btn" onClick={() => setDni('')}>×</button>}
                                </div>

                                <div className="totem-keypad shadow-sm mb-5">
                                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 'DEL', 0, 'OK'].map((k, i) => (
                                        <motion.button
                                            key={i}
                                            whileTap={{ scale: 0.9 }}
                                            className={`keypad-btn-totem ${k === 'OK' ? 'key-confirm' : k === 'DEL' ? 'key-delete' : ''}`}
                                            onClick={() => {
                                                if (k === 'DEL') handleKeypadDelete();
                                                else if (k === 'OK') handleConfirmTurn();
                                                else handleKeypadPress(k);
                                            }}
                                        >
                                            {k}
                                        </motion.button>
                                    ))}
                                </div>

                                <button
                                    className="confirm-huge-btn"
                                    onClick={handleConfirmTurn}
                                    disabled={loading || dni.length < 7}
                                >
                                    {loading ? <Spinner animation="border" /> : <><FontAwesomeIcon icon={faPrint} className="mr-3" /> IMPRIMIR TURNO</>}
                                </button>
                            </motion.div>
                        )}

                        {step === 'success' && (
                            <motion.div
                                key="step3"
                                initial={{ opacity: 0, scale: 0.9 }}
                                animate={{ opacity: 1, scale: 1 }}
                                className="workflow-content success-view text-center"
                            >
                                <div className="success-icon-wrapper mb-4">
                                    <FontAwesomeIcon icon={faCheckCircle} className="success-check-anim" />
                                </div>
                                <h1 className="success-title mb-2">¡TODO LISTO!</h1>
                                <p className="text-muted h4 mb-5">Recoja su ticket e ingrese a la sala</p>

                                <div className="ticket-card-premium mx-auto mb-5">
                                    <div className="ticket-header">SU TURNO ES</div>
                                    <div className="ticket-number">{resultTurn}</div>
                                    <div className="ticket-footer">{selectedType?.TipoNombre}</div>
                                    <div className="ticket-cut-line"></div>
                                </div>

                                <div className="auto-reset-label">
                                    Esta pantalla se reiniciará en unos segundos...
                                </div>

                                <button className="btn-finish-totem mt-4" onClick={resetFlow}>
                                    ACEPTAR
                                </button>
                            </motion.div>
                        )}

                        {step === 'error' && (
                            <motion.div
                                key="error"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                className="workflow-content text-center"
                            >
                                <FontAwesomeIcon icon={faMapMarkerAlt} size="5x" className="text-danger mb-4 opacity-50" />
                                <h2 className="mb-4">TÓTEM NO CONFIGURADO</h2>
                                <p className="text-muted mb-5">Falta asignar una sucursal vía URL o almacenamiento local.</p>
                                <div className="p-3 -glass rounded">
                                    <code>?sucursalId=xxx</code>
                                </div>
                            </motion.div>
                        )}
                    </AnimatePresence>
                </div>
            </div>

            {/* DOM exclusivo de impresión térmica */}
            {step === 'success' && (
                <div className="print-only">
                    <div style={{ textAlign: 'center', marginBottom: '15px', borderBottom: '1px dashed black', paddingBottom: '10px' }}>
                        <h2 style={{ margin: 0, fontSize: '24px', fontWeight: 'bold' }}>TU FILA</h2>
                        <p style={{ margin: 0, fontSize: '14px' }}>Por favor aguarde a ser llamado</p>
                    </div>
                    <div style={{ textAlign: 'center', margin: '10px 0' }}>
                        <p style={{ fontSize: '14px', margin: 0 }}>{selectedType?.TipoNombre}</p>
                        <h1 style={{ fontSize: '40px', margin: '5px 0', fontWeight: 'bold' }}>{resultTurn}</h1>
                        <p style={{ fontSize: '12px', margin: 0 }}>DNI: {dni}</p>
                    </div>
                    <div style={{ textAlign: 'center', fontSize: '10px', marginTop: '15px', borderTop: '1px dashed black', paddingTop: '5px' }}>
                        <p style={{ margin: 0 }}>{new Date().toLocaleDateString()} - {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</p>
                        <p style={{ margin: 0, marginTop: '2px' }}>¡Gracias por su visita!</p>
                    </div>
                </div>
            )}

            <style>{`
                .totem-split-container {
                    display: flex;
                    height: 100vh;
                    width: 100vw;
                }
                .totem-media-panel {
                    width: 40%;
                    height: 100%;
                    position: relative;
                    background: #000;
                    overflow: hidden;
                }
                .totem-workflow-panel {
                    flex: 1;
                    height: 100%;
                    background: #0f172a;
                    padding: 4rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: -20px 0 50px rgba(0,0,0,0.5);
                    z-index: 10;
                    border-left: 1px solid rgba(255,255,255,0.05);
                }
                .workflow-content { width: 100%; }

                /* Branch Badge */
                .branch-badge {
                    display: inline-flex;
                    align-items: center;
                    background: rgba(99, 102, 241, 0.1);
                    color: var(--turnero-primary);
                    padding: 8px 20px;
                    border-radius: 30px;
                    font-size: 0.9rem;
                    font-weight: 700;
                    border: 1px solid rgba(99, 102, 241, 0.2);
                }

                /* Sector Grid */
                .sector-grid-totem {
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                }
                .totem-sector-btn {
                    background: rgba(255,255,255,0.03);
                    border: 1px solid rgba(255,255,255,0.05);
                    border-radius: 20px;
                    padding: 2rem;
                    position: relative;
                    overflow: hidden;
                    text-align: left;
                    transition: all 0.3s;
                }
                .totem-sector-btn:hover {
                    background: rgba(99, 102, 241, 0.1);
                    border-color: var(--turnero-primary);
                }
                .btn-inner { display: flex; align-items: center; gap: 20px; }
                .type-acronym {
                    background: var(--turnero-primary);
                    color: white;
                    width: 70px;
                    height: 70px;
                    border-radius: 15px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.5rem;
                    font-weight: 900;
                }
                .type-name { font-size: 1.8rem; font-weight: 700; color: white; flex: 1; }
                .arrow-icon { color: rgba(255,255,255,0.2); font-size: 1.5rem; }

                /* DNI Display */
                .dni-input-display {
                    background: rgba(0,0,0,0.3);
                    border-radius: 20px;
                    padding: 1.5rem 2rem;
                    display: flex;
                    align-items: center;
                    gap: 20px;
                    border: 1px solid rgba(255,255,255,0.1);
                }
                .dni-icon { font-size: 2.5rem; color: var(--turnero-primary); opacity: 0.5; }
                .dni-numbers { font-size: 3.5rem; font-weight: 800; color: white; flex: 1; font-family: monospace; }
                .dni-numbers .placeholder { opacity: 0.1; }
                .clear-btn { background: none; border: none; color: #ef4444; font-size: 2rem; padding: 0 10px; }

                /* Keypad */
                .totem-keypad {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 15px;
                }
                .keypad-btn-totem {
                    background: rgba(255,255,255,0.05);
                    border: 1px solid rgba(255,255,255,0.1);
                    color: white;
                    padding: 30px;
                    border-radius: 20px;
                    font-size: 2rem;
                    font-weight: 700;
                    transition: all 0.2s;
                }
                .key-delete { color: #ef4444; font-size: 1.2rem; }
                .key-confirm { background: var(--turnero-primary); font-size: 1.2rem; }

                .confirm-huge-btn {
                    width: 100%;
                    background: var(--turnero-primary);
                    color: white;
                    border: none;
                    padding: 1.5rem;
                    border-radius: 20px;
                    font-size: 1.8rem;
                    font-weight: 800;
                    box-shadow: 0 20px 40px -10px rgba(99, 102, 241, 0.5);
                }

                /* Ticket Card Success */
                .ticket-card-premium {
                    background: white;
                    color: #0f172a;
                    width: 320px;
                    padding: 3rem 2rem;
                    border-radius: 4px;
                    position: relative;
                }
                .ticket-header { font-size: 0.9rem; font-weight: 800; opacity: 0.5; margin-bottom: 0.5rem; }
                .ticket-number { font-size: 5rem; font-weight: 900; line-height: 1; margin-bottom: 1rem; color: #000; }
                .ticket-footer { font-size: 1.2rem; font-weight: 700; border-top: 2px dashed #e2e8f0; padding-top: 1rem; }

                .brand-floating-logo {
                    position: absolute;
                    top: 40px;
                    left: 40px;
                    background: rgba(15, 23, 42, 0.8);
                    backdrop-filter: blur(10px);
                    padding: 10px 25px;
                    border-radius: 12px;
                    color: white;
                    border: 1px solid rgba(255,255,255,0.1);
                }

                @media print {
                    @page {
                        size: 80mm auto;
                        margin: 0;
                    }
                    .totem-split-container {
                        display: none !important;
                    }
                    .print-only {
                        display: block !important;
                        width: 80mm !important;
                        padding: 10mm 5mm !important;
                        margin: 0 !important;
                        background: white !important;
                        color: black !important;
                        font-family: Arial, sans-serif !important;
                    }
                    body {
                        background: white !important;
                        margin: 0 !important;
                        padding: 0 !important;
                    }
                }
            `}</style>
        </div>
    );
};

export default TurnTotem;
